import { FormData, ProductData, SheetData } from "./stolarz_form_types";

export const defaultEdge = { label: "--wybierz (brak obrzeża)--", value: "" };
export const defaultEdgeCode1mm = 'PCV 1 mm';
export const defaultSheetForm: SheetData = {
    itemName: "",
    itemComment: "",
    materialCode: "W-962 ST-2",
    length: 100,
    width: 100,
    useGrain: true,
    amount: 1,
    edgeLeft: { edgeCode: "" },
    edgeRight: { edgeCode: "" },
    edgeUp: { edgeCode: "" },
    edgeDown: { edgeCode: "" },
};
export const defaultProductForm: ProductData = {
    productName: "Zestaw",
    amount: 1,
    sheets: [defaultSheetForm]
};
export const defaultForm: FormData = {
    address: "", city: "", email: "", name: "", nip: "", postalCode: "", products: [defaultProductForm], summary: "", 
    // savedProductSelection: ""
};
